import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import UomForm from '../../../components/masters/uom/UomForm';
import UomTable from '../../../components/masters/uom/UomTable';
import { fetchUoms, addUom, updateUom, deleteUom, setUomEdit, clearUomEdit } from '../../../redux/actions/masters/uom/uomAction';
import { fetchCompanies } from '../../../redux/actions/masters/company/companyAction';
import { fetchUsers } from '../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginRight: 0,
};
const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .uom-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .uom-form, .uom-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const UomPage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingUom, formSuccess, formError } = useSelector(state => state.uom || {});
  const { list: companies = [] } = useSelector(state => state.company || {});
  const users = useSelector(state => state.users.list || []);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchUoms());
    dispatch(fetchCompanies());
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearUomEdit());
  };

  const handleSubmit = async (form) => {
    if (editingUom && editingUom.uom_id) {
      await dispatch(updateUom(editingUom.uom_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addUom(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (uom) => {
    dispatch(setUomEdit(uom));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteUom(id));
  };

  const handleCancel = () => {
    dispatch(clearUomEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      u => u.uom_code === code && (!excludeId || u.uom_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={containerStyle} className="uom-flex">
        <div style={tableContainer} className="uom-table">
          <UomTable
            onNew={handleFormReset}
            uoms={list}
            onEdit={handleEdit}
            onDelete={handleDelete}
            loading={loading}
          />
        </div>
        <div style={formContainer} className="uom-form">
          <UomForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingUom={editingUom}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default UomPage; 